export const WARN = {
  UNSAVED_CHANGES: 'You have unsaved changes. Are you sure you want to exit?',
  UPLOAD_IN_PROGRESS: 'File upload in progress. Are you sure you want to exit?',
};
